import { Injectable } from '@angular/core';
import { Actions, createEffect } from '@ngrx/effects';
import { fromEvent } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { SET_OPENEDTASKS_TYPE } from '../openedTasks';
import { SET_SESSIONREFRESH_TYPE } from '../sessionRefreshState';
import { DELETE_USER_TYPE, SET_USER_TYPE } from '../user';
import { SET_USERPREFS_TYPE } from '../userPrefs';

@Injectable()
export class AppStateEffects {

  onChange = createEffect(() => fromEvent<StorageEvent>(window, 'storage').pipe(
    filter(evt => evt.key === 'sessionRefresh'
      || evt.key === 'user'
      || evt.key === 'userPrefs'
      || evt.key === 'openedTasks'
    ),
    filter(evt => evt.newValue !== null && evt.oldValue !== evt.newValue)
    , map(evt => {
      console.log('Actualización de datos de la pestaña desde el localstorage', evt);
      const newValue = JSON.parse(evt.newValue);
      switch (evt.key) {
        case 'openedTasks':
          return { type: SET_OPENEDTASKS_TYPE, tasks: newValue, avoidPersistence: true };
        case 'user':
          if (!newValue?.accessToken) {
            return { type: DELETE_USER_TYPE };
          } else {
            return { type: SET_USER_TYPE, sessionInfo: newValue, avoidPersistence: true };
          }
        case 'userPrefs':
          return { type: SET_USERPREFS_TYPE, userPrefs: newValue, avoidPersistence: true };
        case 'sessionRefresh':
          return { type: SET_SESSIONREFRESH_TYPE, state: newValue, avoidPersistence: true };
      }
    })
  ),
    { dispatch: true }
  );

  constructor(
    private actions$: Actions
  ) { }

}
